//replace shop now button URL
document.addEventListener('DOMContentLoaded', function () {
 const oldButton = document.getElementById('inveterate-identification-shopnow');
  
  if (oldButton) {
      const newButton = document.createElement("button");
      newButton.id = "new-button-id";
      newButton.textContent = "Shop Now";
      newButton.classList.add("inveterate__button__primary");
      newButton.addEventListener("click", () => {
        window.location.href = 'https://www.gruntstyle.com/collections/best-sellers';
      });
      
      oldButton.parentNode.replaceChild(newButton, oldButton);
  }
  
});

//update title
document.title = "Grunt Style Rewards | Grunt Style LLC";

//Replace birthday text
document.addEventListener('DOMContentLoaded', function () {
  let birthdayAmount = '$5';
  if (window.inveterate.customer.tier.segmentId == '9b7d1d48') {
    birthdayAmount = '$15'
  } else if (window.inveterate.customer.tier.segmentId == 'd044e920') {
    birthdayAmount = '$20'
  } 
  document.querySelector('.inveterate__member__birthday_credits_description').textContent = `${ birthdayAmount } for surviving another year like a true patriot. Add your birthday and Lock and load.`;
})


// 1. Intercept clicks on the custom tier ATC buttons
document.addEventListener('click', (event) => {
  const btn = event.target.closest('[inveterate-tier-atc-button]');
  if (!btn) return;

  handleTierAtcClick.call(btn, event);
});



// 1(B). intercept button on for upgrades
document.addEventListener('DOMContentLoaded', function () {

  const changePlanBtn = document.querySelector('[data-inveterate-action="open-tier-selection"]');

  if (changePlanBtn) {

    changePlanBtn.addEventListener('click', function (event) {
      console.log('Change Plan button clicked');

      setTimeout(() => {
        document.querySelectorAll('[inveterate-loader^="inveterate-atc-"]').forEach(btn => {
          console.log('My button', btn.innerText)
          if (btn.innerText == 'Upgrade') {
            btn.addEventListener('click', function(event) {
              handleTierAtcClick.call(this, event);
            });
          }
        });
      }, 500); 
    });
  } else {
    console.warn('Change Plan button not found');
  }
});




// 2. Setup for controlled triggering
let cartMonitorInitialized = false;
let allowCartUpdateTrigger = false;

function handleTierAtcClick(event) {
  allowCartUpdateTrigger = true;            // Enable just before the action
  startCartFetchMonitoring();               // Ensure patch is applied
}



// 3. Patch fetch once, conditionally trigger on mutations
function startCartFetchMonitoring() {
  if (cartMonitorInitialized) return;
  cartMonitorInitialized = true;

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const [url] = args;
    const response = await originalFetch(...args);

    const isCartUpdate =
      typeof url === 'string' &&
      (url.includes('/cart/add.js') ||
       url.includes('/cart/change.js') ||
       url.includes('/cart/update.js'));

    // Only act if we're allowed to handle this specific mutation
    if (isCartUpdate && allowCartUpdateTrigger) {
      allowCartUpdateTrigger = false;  // disable immediately after triggering

      
      setTimeout(() => {
        // Step 1: fetch updated section
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            updates: {},
            sections: 'ajax-cart-drawer'
          })
        })
          .then(res => res.json())
          .then(sectionResponse => {
            // Step 2: fetch cart data
            fetch('/cart.js')
              .then(res => res.json())
              .then(cartData => {
                console.log('my cart data ',cartData)
                const combined = {
                  sections: sectionResponse.sections,
                  cart: cartData
                };
                cartContentUpdate(combined, 'ajax-cart-drawer');
                
                
              }).finally(() => {
                drawerProductRecommendation();
                window.initGoodszillaWidget()

                // let cartDrawer = document.querySelector("#ajax-cart-drawer");  
                // if(cartDrawer){
                //   cartDrawer.classList.add("sidebar-visible");
                // }               
                // cartDrawer.style.display = "flex"; 
              
              });
          })
          .catch(err => console.error('❌ Error updating cart:', err));
      }, 300);
    }

    return response;
  };
}